/**
 * Arbitration Page
 * 
 * Page wrapper for the ArbitrationPanel component
 * Handles routing and layout integration
 */

import React from 'react';
import { ArbitrationPanel } from '../components/arbitration';

const ArbitrationPage: React.FC = () => {
  return <ArbitrationPanel />;
};

export default ArbitrationPage;

